import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const sendEmailCarrier = createProvider(api.sendEmailCarrier).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Send email to carrier aborted');
  } else {
    console.error('Send email to carrier was failed:', error);
  }
  throw error;
});
